const products = {
  products: "Products",
  requestsList: "Requests List",
  requests: "Requests",
  productsList: "Products List",
  list: {
    tabs: {
      pending: "Pending",
      rejected: "Rejected",
      cancelled: "Cancelled",
      published: "Published",
      unpublished: "Unpublished",
      deleted: "Deleted"
    },
    status: {
      edited: "Edited",
      newRequest: "New Request",
      pending: "Pending",
      cancelled: "Cancelled",
      rejected: "Rejected"
    },
    noProductsFound: "No Products Found",
    searchPlaceholder: "Search by Product or Company Name",
    tableHeader: {
      product: "Product",
      category: "Category",
      subCategory: "Sub Category",
      companyName: "Company Name",
      companyCountry: "Company Country",
      requestDate: "Request Date",
      rejectDate: "Rejection Date",
      cancelDate: "Cancellation Date",
      publishDate: "Publishing Date",
      unpublishDate: "Unpublishing Date",
      deleteDate: "Deletion Date",
      status: "Status"
    },
    filters: {
      categories: "Categories",
      subCategories: "Sub Categories",
      status: "Status",
      countries: "Countries",
      companies: "Companies",
      dateRange: "Date Range",
      searchPlaceholders: {
        categories: "Search by category name",
        subCategories: "Search by sub category name",
        countries: "Search by country name",
        companies: "Search by company name",
        noSubcategories:
          "The selected category doesn't have any subcategories."
      }
    },
    productRejectionTooltip:
      "has been rejected because of these reasons:"
  },
  productDetails: {
    productDetails: "Product Details",
    noProductFound: "No product found",
    productStatus: "Product Status",
    productCode: "Product Code",
    minimumQuantity: "Minimum Quantity",
    pricing: "Pricing",
    items: "Items",
    country: "Country",
    overview: "Overview",
    description: "Description",
    specifications: "Specifications",
    downloadTheCatalogue: "Download The Catalogue",
    productVideo: "Product Video",
    searchingKeywords: "Searching Keywords",
    rejectionReason:
      "The product has been rejected because it doesn’t comply with ExGates regulations",
    actions: {
      accept: "Accept",
      reject: "Reject"
    },
    status: {
      pending: "Pending",
      published: "Published",
      unpublished: "Unpublished",
      draft: "Draft",
      edited: "Edited",
      rejected: "Rejected",
      deleted: "Deleted",
      cancelled: "Cancelled",
      new_request: "New Request"
    }
  },
  reviewProduct: {
    approve: "Approve",
    approveConfirmMsg:
      "Are you sure you want to approve this product?",
    rejectMsg: "Please clarify the reason to reject",
    rejectionReason:
      "The product doesn’t comply with ExGates regulations",
    otherReasons: "Other Reasons",
    typeHere: "Type Here",
    reject: "Reject",
    cancel: "Cancel"
  },
  productCard: { moq: "MOQ" }
};

export default products;
